import queryString from 'query-string';
import { findParamFromUrl, getFromSessionStorage, setInSessionStorage, getQueryString, isSingleUpgradeOrShiftingJourney } from 'common/utils/app.utils';
import { JOURNEY_TYPE, PRODUCT_NAME, PRODUCT_TYPE, USER_TYPE, USER_TYPE_KAM, DEDICATED_COMMON_PARAMS } from 'common/constants/app.constants';
import {
  COMMON_API_HEADERS,
  AUTHORIZED_SIGNATORY,
  MODULE_ID,
  AUTHORIZATION_HEADER,
  LEAD,
  ORDER,
  OV_TOKEN,
  PNQ_AUTHORIZATION_HEADER,
  SUMMARY_AUTHORIZATION_HEADER
} from './constant';
import { IAuthorizedSignatory } from './lead.interface';
import { AUTH_TOKEN, MULTI_SITE_MODULE_ID, CART_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import { faOnDedicatedHomePageLoad } from 'dedicated/services/analytics.service';

export const isUserTypeIsKAM = () => getFromSessionStorage(MODULE_ID, USER_TYPE) === USER_TYPE_KAM;

export const getUTMParams = () => {
  let utmParams = queryString.parse(window && window.location.search);
  const isValidUTM = utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign;
  if (isValidUTM) {
    return {
      source: utmParams?.utm_source ?? null,
      medium: utmParams?.utm_medium ?? null,
      campaign: utmParams?.utm_campaign ?? null
    };
  }
  return null;
};

export const saveToken = (leadResponse: any) => {
  const token = leadResponse?.headers?.authorization_token ?? leadResponse?.headers?.authorization;
  localStorage?.setItem('storageTime', new Date()?.toString());

  if (isUserTypeIsKAM() || isSingleUpgradeOrShiftingJourney()) {
    setInSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER, token);
  } else {
    setInSessionStorage(MODULE_ID, AUTHORIZATION_HEADER, token);
    setInSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN, token);
  }
};

export const saveSummaryToken = (token: string) => {
  setInSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER, token);
  setInSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN, token);
};

export const saveCartIdFromParams = () => {
  const queryParams = getQueryString() as { cartId: string };
  setInSessionStorage(MULTI_SITE_MODULE_ID, CART_ID, queryParams?.cartId);
};

export const saveSelectedProductType = (selectedProductType: string) => {
  setInSessionStorage(MODULE_ID, PRODUCT_NAME, selectedProductType);
  DEDICATED_COMMON_PARAMS.serviceType = selectedProductType;
};

export const saveAuthorizedSignatory = (leadResponse: any) => {
  const lead = leadResponse?.data?.result;
  setAuthorizedSignatoryData(lead?.authorizedSignatory, lead?.customerSegment);
};

export const saveLob = (leadResponse: any) => {
  const lob = leadResponse?.data?.result?.lob[0];
  setInSessionStorage(MODULE_ID, 'AehLob', lob);
};

export const updateLeadAnalytics = (leadResponse: any) => {
  const segment = leadResponse?.data?.result?.customerSegment;
  faOnDedicatedHomePageLoad({ segment, productType: DEDICATED_COMMON_PARAMS.serviceType });
};

export const saveLead = (lead: any) => {
  setInSessionStorage(MODULE_ID, LEAD, lead);
};

export const saveOrder = (order: any) => {
  setInSessionStorage(MODULE_ID, ORDER, order);
};

export const saveOvToken = (order: any) => {
  setInSessionStorage(MODULE_ID, OV_TOKEN, order);
};

export const getCurrentLead = () => {
  return getFromSessionStorage(MODULE_ID, LEAD) ?? null;
};

export const getCurrentOrder = () => {
  return getFromSessionStorage(MODULE_ID, ORDER) ?? null;
};

export const getOvToken = () => {
  return getFromSessionStorage(MODULE_ID, OV_TOKEN) ?? null;
};

export const getFeasibilityStaus = (savedLead: any) => {
  return savedLead?.lineItems[0]?.plan?.site[0]?.feasibilityResponse?.feasibilityStatus;
};
export const setAuthorizedSignatoryData = (kdmDetails: any, customerSegment: any) => {
  if (kdmDetails && customerSegment) {
    const authorizedSignatory = {} as IAuthorizedSignatory;
    const firstName = kdmDetails?.firstName ?? '';
    const lastName = ` ${kdmDetails.lastName} `;
    authorizedSignatory.kdmName = firstName + lastName;
    authorizedSignatory.email = kdmDetails && kdmDetails.email ? kdmDetails.email : '';
    authorizedSignatory.mobile = kdmDetails && kdmDetails.phoneNumber ? kdmDetails.phoneNumber : '';
    authorizedSignatory.companyName = kdmDetails && kdmDetails.companyName ? kdmDetails.companyName : '';
    authorizedSignatory.customerSegment = customerSegment ?? '';
    setInSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY, authorizedSignatory);
  }
};

export const isBulkUpgrade = () => {
  const activeLead = getCurrentLead();
  const orderType = activeLead?.orderType ?? null;
  const journeyTypeFromParam = findParamFromUrl('journey', false);
  if (journeyTypeFromParam && journeyTypeFromParam === JOURNEY_TYPE.BULK_UPGRADE) {
    return true;
  }
  return orderType && orderType === 'CHANGE_ORDER';
};
